import { signals2DToZ } from '../signals/signals2DToZ';
import { signalsToXY } from '../signals/signalsToXY';
import { getFrequency } from '../utilities/getFrequency';
import { predictAll } from './predictAll';
export async function predictAllSpectra(molecule, options = {}) {
    const { simulation: simulationOptions = { oneD: {}, twoD: {} }, prediction: predictionOptions = {}, } = options;
    const predictions = await predictAll(molecule, predictionOptions);
    const spectra = [];
    const result = { spectra, molecules: [{ molfile: predictions.molfile }] };
    const oneDOptions = {
        ...{
            proton: { from: 0, to: 14 },
            carbon: { from: 0, to: 200 },
            nbPoints: 4098,
            lineWidth: 0.03,
        },
        ...(simulationOptions.oneD || {}),
    };
    const twoDOptions = {
        ...{
            from: { x: oneDOptions.proton.from, y: oneDOptions.carbon.from },
            to: { x: oneDOptions.proton.to, y: oneDOptions.carbon.to },
            nbPoints: { x: 1024, y: 1024 },
        },
        ...(simulationOptions.twoD || {}),
    };
    for (const experiment in predictions) {
        switch (experiment) {
            case 'carbon':
            case 'proton': {
                spectra.push(get1DSpectrum(predictions[experiment], {
                    nbPoints: oneDOptions.nbPoints,
                    lineWidth: oneDOptions.lineWidth,
                    ...oneDOptions[experiment],
                    experiment,
                    frequency: simulationOptions.frequency,
                }));
                break;
            }
            case 'cosy':
            case 'hsqc':
            case 'hmbc': {
                spectra.push(get2DSpectrum(predictions[experiment], {
                    ...twoDOptions,
                    experiment,
                    frequency: simulationOptions.frequency,
                }));
                break;
            }
            default:
                break;
        }
    }
    return result;
}
function get2DSpectrum(prediction, options) {
    const { signals, zones, nuclei } = prediction;
    const { frequency: baseFrequency, experiment } = options;
    const width = get2DWidth(nuclei);
    const frequency = calculateFrequency(nuclei, baseFrequency);
    const spectrumData = signals2DToZ(signals, {
        ...options,
        width,
        factor: 3,
    });
    const spectrum = {
        data: { ...spectrumData, noise: 0.01 },
        info: {
            nucleus: nuclei,
            originFrequency: frequency,
            baseFrequency: frequency,
            pulseSequence: experiment,
            experiment: '2d',
        },
        zones: { values: zones },
    };
    return spectrum;
}
function get2DWidth(nucleus) {
    return nucleus[0] === nucleus[1] ? 0.02 : { x: 0.02, y: 0.2133 };
}
function get1DSpectrum(prediction, options) {
    const { frequency = 400, experiment } = options;
    const { signals, nucleus } = prediction;
    const realFrequency = calculateFrequency(nucleus, frequency);
    const { x, y } = signalsToXY(signals, {
        ...options,
        frequency: realFrequency,
    });
    const spectrum = {
        // todo Array.from is temporary for the developement
        data: { x: Array.from(x), re: Array.from(y), im: null },
        info: {
            nucleus: prediction.nucleus,
            dimension: 1,
            originFrequency: realFrequency,
            baseFrequency: realFrequency,
            pulseSequence: 'prediction',
            experiment,
            isFt: true,
        },
        ranges: { values: prediction.ranges },
    };
    return spectrum;
}
function calculateFrequency(nucleus, frequency) {
    if (typeof nucleus === 'string') {
        return getFrequency(nucleus, { nucleus: '1H', frequency });
    }
    else {
        if (nucleus[0] === nucleus[1]) {
            return `${frequency},${frequency}`;
        }
        else {
            return `${frequency},${getFrequency(nucleus[1], {
                nucleus: nucleus[0],
                frequency,
            })}`;
        }
    }
}
//# sourceMappingURL=predictAllSpectra.js.map